import { ACTIVITY_FEED_CODES } from "~/providers/constants";
import { getFullName } from "../GetFullName";
import { PatientFeed } from "../types/interactions";

export const getExtraInfo = (feed: PatientFeed) => {
  if (feed.code === ACTIVITY_FEED_CODES.patient_promoted_to_intake) {
    const primaryProvider =
      feed.context.data.consultation.organization_patient.primary_provider;
    const primaryProviderName = primaryProvider?.name;

    const primaryProviderLastName = primaryProvider?.last_name;

    const primaryProviderFullName = getFullName(
      primaryProviderName,
      primaryProviderLastName,
    );

    if (primaryProvider?.id == feed.provider_id) return;

    if (primaryProvider) {
      return `Assigned to ${primaryProviderFullName}`;
    } else {
      return "Unassigned";
    }
  }
};
